import { cleanGarmentDisplayName } from './garment-display-name';

/**
 * A blank's style name, for a buy surface that shows colour and size on their
 * own (Buy first's Colour and Size columns, a just-in-time PO line's
 * "Staple Tee · Black · M", To buy, the add-blank picker).
 *
 * Base garments write a blank's SKU title as
 * `concat_ws(' ', name, size, colour)` ("Staple Tee M Black"), so the title
 * already ends in the line's own size and colour. Only that exact tail comes
 * off: the line's own size then colour, as whole words, compared without case.
 * Any other colour word stays ("Black Label Tee"), and a name is never
 * stripped to nothing. A Shopify-style title ("Staple Tee - Black / M") falls
 * through to `cleanGarmentDisplayName`.
 *
 * Kept apart from `cleanGarmentDisplayName` on purpose: that one names
 * garments on the production stations (Catching, Print, Pressing), whose
 * names must not change when a buy surface's rule does.
 */
export function blankStyleName(title: string, colour: string | null, size: string | null): string {
  const name = title.trim();
  const words = [size?.trim(), colour?.trim()].filter((part): part is string => Boolean(part));
  if (words.length === 0) return name;

  // The suffix is compared on the title's own trailing characters, so a
  // case fold that changes a string's length can never shift the cut.
  const suffix = ` ${words.join(' ')}`;
  if (name.slice(-suffix.length).toLowerCase() === suffix.toLowerCase()) {
    const kept = name.slice(0, -suffix.length).trimEnd();
    if (kept) return kept;
  }
  return cleanGarmentDisplayName(name, colour?.trim() || null, size?.trim() || null);
}
